export const determineIfLowStock = function(skus) {
  // Definition of "low stock" according to Looker "Product Availability" dashboard:
  // => less than half of the size curve available
  const soldOutSkus = skus.reduce((soldOutSkus, sku) => {
    if (sku.stock === 0) soldOutSkus.push(sku)
    return soldOutSkus
  }, [])
  return soldOutSkus.length > skus.length / 2
}

export const determineIfSoldOut = function(skus) {
  return skus.find(sku => sku.stock > 0) === undefined
}

export const determineIfLastChance = function(skus, isBackorderable) {
  return determineIfLowStock(skus) && !isBackorderable
}
